import React from "react";
import HandholderAssignment from "./HandholderAssignment";
import SelectServiceRequestNamesDropdown from "../Handholder/SelectServiceRequestNamesDropdown";
import SelectServiceRequestStatusDropdown from "../Handholder/SelectServiceRequestStatusDropdown";
import SelectPaymentStatusDropdown from "../Handholder/SelectPaymentStatusDropdown";

import Checkbox from "../../../common/Checkbox/Checkbox";
import { ControlledInput } from "../../../common/Input/Input";
import { Button } from "../../../common/Button/Button";
import Select from "react-select";
import SelectFollowupDateDropdown from "../Handholder/SelectFollowupDateDropdown";
import SelectSPMStatusDropdown from "../Facilitator/SelectSPMStatusDropdown";
import MultiSelectAll from "../../../common/Multiselect/MultiSelectAll";
import { X } from "react-feather";
import newFacilitatorListSample from "../../../assets/newFacilitatorListSample.csv";

export default function Actions(props) {
	return (
		<>
			<div className="row">
				<div className={props.useForSPM?("col-md-3"):("col-md-12")}>
					<HandholderAssignment
						downloadOutboundUploadLogs={
							props.downloadOutboundUploadLogs
						}
						uploadOutboundReport={props.uploadOutboundReport}
						onOutboundUpload={props.onOutboundUpload}
						selectedServiceRequestsHasHandholder={
							props.selectedServiceRequestsHasHandholder
						}
						numberOfServices={
							props.useForSPM
								? props.selectedServiceRequests.length
								: props.numberOfServices
						}
						assignFacilitators={props.assignFacilitators}
						selectedHandholder={
							props.useForSPM
								? props.selectedFacilitator
								: props.selectedHandholder
						}
						onSelectHandholder={props.onSelectHandholder}
						handholderList={props.handholderList}
						facilitatorList={props.facilitatorList}
						onAssignHandholder={props.onAssignHandholder}
						onUnAssignHandholder={props.onUnAssignHandholder}
						generateCallingReport={props.generateCallingReport}
					/>
				</div>

				<div className={props.useForSPM?("col-md-9"):("col-md-12")}>
					{props.useForSPM ? (
						<div className="row" style={{marginTop:"5px"}}>
							<div className="col-md-12">
								<label><b>Filter and search</b></label>
								<div className="row">
									<div className="col-md-12 inline-margin" >
										<div className={`error-popup ${props.filterError ? "show" : ""}`}>
											Please select filter to search on.
										</div>
										<Select
											placeholder="Select Search Filter"
											options={
												props.useForSPM
													? [
															{
																value: "F_email",
																label: "Facilitator email",
															},
															{
																value: "C_email",
																label: "Customer email",
															},
															{
																value: "nPackageInstanceId",
																label: "Package/Offering Instance ID",
															},
													]
													: [
															{
																value: "HH_email",
																label: "Handholder email",
															},
															{
																value: "C_email",
																label: "Customer email",
															},
															{
																value: "nPackageInstanceId",
																label: "Package/Offering Instance ID",
															},
													]
											}
											onChange={props.onSearchFilterChange}
											value={props.searchFilter}
											className={`${props.filterError ? "border-error" : ""}`}
										/>
										<ControlledInput
											placeholder="Search..."
											// onChange={(event) => { event.persist();debounce(() => {props.onSearchInputChange(event)},1000)}}
											onChange={props.onSearchInputChange}
											onKeyPress={(e) => {
												if (e.key === "Enter") {
													props.onSearchClicked();
												}
											}}
											value={props.searchTerm}
										/>
										<SelectSPMStatusDropdown
											toggleSelection={props.toggleSPMStatus}
											checkboxItemsList={props.SPMStatusList}
										/>
										<Button className="inline-button" onClick={props.onSearchClicked}>Search</Button>
										<Button className="inline-button"
											onClick={props.onClearFilterSearch}
										>
											Clear
										</Button>
									</div>
								</div>
							</div>
						</div>
						) : 
						(
							<>
								<div className="row" style={{marginTop:"5px"}}>
									<div className="col-md-12 inline-margin-adminview">
										<label>
											<b>Filter and search</b>
										</label>
										{/*<SelectServiceRequestNamesDropdown
											toggleAll={props.toggleAll}
											toggleSelection={props.toggleSelection}
											checkboxItemsList={props.ServiceRequestList}
										/>*/}
										<div className="multi-select"> 
										<MultiSelectAll
												toggleAll={props.toggleAllForFilter}
												toggleSelection={props.toggleSelectionForFilter}
												checkboxItemsList={props.serviceNameListForFilter}
												selectedOptions={props.selectedServiceNameListForFilter}
												placeholderButtonLabel={"Select Services"}
										/>
										</div>
										<div className="multi-select"> 
										<MultiSelectAll
												toggleAll={props.toggleAllForPackageFilter}
												toggleSelection={props.toggleSelectionForPackageFilter}
												checkboxItemsList={props.packageNameListForFilter}
												selectedOptions={props.selectedPackageNameListForFilter}
												placeholderButtonLabel={"Select Packages"}
										/>
										</div>									

										<SelectServiceRequestStatusDropdown
											toggleStatusSelection={
												props.toggleStatusSelection
											}
											checkboxItemsList={
												props.serviceRequestStatusList
											}
										/>
										<SelectPaymentStatusDropdown
											togglePaymentStatus={props.togglePaymentStatus}
											checkboxItemsList={props.paymentStatusList}
										/>
										<div className="small-dropdown">
											<label style={{marginTop:"5px"}}><b>Moved to SPM:</b></label>
											<Select
												placeholder="Select Moved to SPM status"
												options={props.MovedToSPMStatusOptions}
												onChange={props.onMovedToPSMStatusChange}
												value={props.selectedMovedToSPMStatus}
											></Select>
									</div>
									<div className="small-dropdown">
											<label style={{marginTop:"5px"}}><b>Services Through Packages:</b></label>
											<Select
												placeholder="Select Services Through Packages"
												options={props.servicesThroughPackageOptions}
												onChange={props.onServicesThroughPackageOptionChange}
												value={props.selectedServicesThroughPackageOption}
											></Select>
									</div>
									</div>
									<div style={{clear:"both",margin:"5px"}}></div>
									<div className="col-md-12 inline-margin-adminview">
									<SelectFollowupDateDropdown
											followUpDateTo={props.followUpDateTo}
											followUpDateFrom={props.followUpDateFrom}
											setFollowUpDateTo={props.setFollowUpDateTo}
											setFollowUpDateFrom={props.setFollowUpDateFrom}
									/>
									<div className={`error-popup ${props.filterError ? "show" : ""}`}>
										Please select filter to search on.
									</div>
										<Select
											placeholder="Select Search Filter"
											options={
												props.useForSPM
													? [
															{
																value: "F_email",
																label: "Facilitator email",
															},
															{
																value: "C_email",
																label: "Customer email",
															},
															{
																value: "nPackageInstanceId",
																label: "Package/Offering Instance ID",
															},
													]
													: [
															{
																value: "HH_email",
																label: "Handholder email",
															},
															{
																value: "C_email",
																label: "Customer email",
															},
															{
																value: "nPackageInstanceId",
																label: "Package/Offering Instance ID",
															},
													]
											}
											onChange={props.onSearchFilterChange}
											value={props.searchFilter}
											className={`${props.filterError ? "border-error" : ""}`}
										/>
										<ControlledInput
											placeholder="Search..."
											// onChange={(event) => { event.persist();debounce(() => {props.onSearchInputChange(event)},1000)}}
											onChange={props.onSearchInputChange}
											onKeyPress={(e) => {
												if (e.key === "Enter") {
													props.onSearchClicked();
												}
											}}
											value={props.searchTerm}
										/>
										
									
										<Button className="inline-button" onClick={props.onSearchClicked}>Search</Button>
										<Button className="inline-button" onClick={props.onClearFilterSearch}>
											Clear
										</Button>
									</div>
								</div>
							</>
						)}
				</div>
				{props.useForSPM ? 
				(
					<div className="col-md-12">
						<div className="row" style={{marginTop:"5px",marginBottom:"5px"}}>
							<div className="col-md-12 inline-margin-adminview">
								<div className="multi-select"> 
									<MultiSelectAll
											toggleAll={props.toggleAllForPackageFilter}
											toggleSelection={props.toggleSelectionForPackageFilter}
											checkboxItemsList={props.packageNameListForFilter}
											selectedOptions={props.selectedPackageNameListForFilter}
											placeholderButtonLabel={"Select Packages"}
									/>
								</div>	
								<div className="small-dropdown">
									<label style={{marginTop:"5px"}}><b>Services Through Packages:</b></label>
									<Select
										placeholder="Select Services Through Packages"
										options={props.servicesThroughPackageOptions}
										onChange={props.onServicesThroughPackageOptionChange}
										value={props.selectedServicesThroughPackageOption}
									></Select>
								</div>
								{props.showFeedbackButton?
								(
									<>									
									<button className="notification con-btn-bordered-lg conv-font14 conv-pl15 conv-pr15 con-br0 conv-pt9 conv-pb9 conv-float-left" 
										onClick={()=>{props.onTabChanged("Customer Feedback")}}
										>
										Customer Feedback
										<div className="notification-dot">{props.unReadFeedbackCount}</div>
									</button>
									</>
								)
								:("")}
								<div className="inline-margin-assign-fc conv-ml15">
									<div>
										<Button onClick={props.handleAssignFacilitatorUploadClick}>
											Reassign Facilitator
										</Button>
										{props.isAssignFacilitatorUploadOpen?
										(<div className="divFloat-new">
											<div className="row">
												<div className="col-md-12">
													<input className="form-control-custom"
														ref={props.FileInputref}													
														type="file"
														accept=".csv"
														onChange={props.onAssignFacilitatorUpload}>
													</input>
													<Button onClick={props.uploadAssignFacilitatorFile}>
														Upload
													</Button>													
													<button className="outbound-close" onClick={props.handleAssignFacilitatorUploadClick} >
														<X/>
													</button>							
												</div>
												<div style={{clear:"both",margin:"5px"}}></div>
												<a href={newFacilitatorListSample} download="newFacilitatorListSample.csv"> Download Sample File </a>
											</div>
										</div>
										):("")}
									</div>
								</div>
							</div>
						</div>
					</div>
				):("")}
			</div>
			
			<div className="row">
				<div className="col-md-12 mb-2 ">
					<div className="flex">
						<span>Show only unassigned</span>
						<Checkbox
							id="unassigned-sr"
							checked={props.showUnassignedServiceRequests}
							onChange={props.toggleUnassignedServiceRequests}
						/>
						{false ? (
							""
						) : (
							<>
								<span>
									<b>
										Number of selected services:{" "}
										{props.numberOfServices}{" "}
									</b>
								</span>
								{props.numberOfServices !== 0 ? (
									<b>
										<a
											onClick={
												props.toggleConfirmHandholderAssignmentModal
											}
											style={{
												textDecoration: "underline",
												paddingLeft: "25px",
												cursor: "pointer",
											}}
										>
											Show details
										</a>
									</b>
								) : (
									""
								)}
							</>
						)}

					<span style={{marginLeft:"20px"}}>
					{props.showCount && <>Services filtered : <b>{props.count}</b></>}
					</span>
					</div>
				</div>
				{/* Add user to reports route.  */}
			</div>
		</>
	);
}
